import { commonTranslationKeys } from '@dreryk/react-common';
import { Button, ButtonVariant } from '@dreryk/react-components';

import { NfzSettingsFormController } from './NfzSettingsForm.types';
import { useCurrentHealthcareProviderNfzConfigurationSetCommand } from './NfzSettingsSaveAction.hooks';

type NfzSettingsSaveActionProps = Pick<NfzSettingsFormController, 'handleSubmit'>;

export const NfzSettingsSaveAction = (props: NfzSettingsSaveActionProps): JSX.Element => {
   const { executeAsync: setNfzConfiguration } = useCurrentHealthcareProviderNfzConfigurationSetCommand();

   const handleSubmit = props.handleSubmit(async (formData) => {
      await setNfzConfiguration(formData);
   });

   return (
      <Button
         testId='nfzSettingsSave'
         label={commonTranslationKeys.save}
         onClick={handleSubmit}
         variant={ButtonVariant.PRIMARY}
      />
   );
};
